import { IMentionAttachmentCommentData } from '../comment';
import { IEmployeeData } from '../employee';
import { IUserData } from '../user';

// API Data
export interface IOvertimeRequestData {
  id?: number;
  state?: OvertimeRequestStateEnum;
  employee?: IEmployeeData;
  start: string | Date;
  end: string | Date;
  amount_requested?: number;
  reason: string;
  approvers: IOvertimeApprovalData[];
  attachments: IOvertimeRequestAttachmentData[];
  created_at?: string | Date;
  updated_at?: string | Date;
}

export interface IOvertimeRequestAttachmentData {
  id?: number;
  file: string | File;
  filename?: string;
}

export interface IOvertimeApprovalData {
  id?: number;
  approver: number | IUserData;
  status: OvertimeApprovalState;
  created_at?: string;
  updated_at?: string;
}

export interface IOvertimeRequestStateInfoData {
  display_name: string;
  color: string;
}

export interface IOvertimeRequestFieldErrorData {
  state?: string[];
  employee?: string[];
  owner?: string[];
  start?: string[];
  end?: string[];
  amount_requested?: string[];
  reason?: string[];
  approvers?: IOvertimeApprovalFieldErrorData[];
  attachments?: IOvertimeRequestAttachmentFieldErrorData[];
}

export interface IOvertimeRequestCommentFieldErrorData {
  text?: string[];
}

export interface IOvertimeApprovalFieldErrorData {
  approver: string[];
  status: string[];
}

export interface IOvertimeRequestAttachmentFieldErrorData {
  file: string[];
}

export interface IOvertimeRequest extends IOvertimeRequestData {
  validate(): boolean;
  getStateInfo(): IOvertimeRequestStateInfoData;

  // Manage attachments
  attachFile(file: File): void;
  detachFile(file: File): void;
}

export interface IOvertimeApproval extends IOvertimeApprovalData {
  validate(): boolean;
}

export interface IOvertimeRequestAttachment
  extends IOvertimeRequestAttachmentData {
  validate(): boolean;
}

export interface IOvertimeRequestFieldError
  extends IOvertimeRequestFieldErrorData {
  clearErrors(): void;
}

export interface IOvertimeApprovalFieldError
  extends IOvertimeApprovalFieldErrorData {
  clearErrors(): void;
}

export interface IOvertimeRequestCommentFieldError
  extends IOvertimeRequestCommentFieldErrorData {
  clearErrors(): void;
}

export interface IOvertimeRequestAttachmentFieldError
  extends IOvertimeRequestAttachmentFieldErrorData {
  clearErrors(): void;
}

export enum OvertimeApprovalState {
  Tentative,
  Approved,
  Rejected
}

export enum OvertimeRequestStateEnum {
  Draft,
  Submitted,
  Approved,
  Rejected,
  Cancelled
}
